export default "/images/vendor/flag-icon-css/flags/4x3/wf.svg?f6a164349ff634cf585d539c14d8256a";